import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';
import FocusableButton from 'components/common/FocusableButton';

export default function PeriodCalendarTitle(props) {
  const {
    onClose,
  } = props || {};
  return (
    <div {...ex('PeriodCalendarTitle', props)}>
      {T('기간 선택')}
      <FocusableButton {...{ onClick: onClose }}>
        <svg preserveAspectRatio="none" width="24" viewBox="0 0 24 24" height="24" xmlns="http://www.w3.org/2000/svg"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" /></svg>
      </FocusableButton>
    </div>
  );
}
